import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import travelImg from 'images/tmp_travel_image.png'
import styles from './index.module.css'

const TravelDetail7 = () => {

	const App = useApp()
	const [toggleButton, setToggleButton] = useState(false)

	const moreOpen = () => {
		setToggleButton(!toggleButton)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="img-box" style={{ height: "26rem" }}>
					<img src={travelImg} alt="" />
				</div>
				<div className={styles["travel-guide"]}>
					<div className={`${styles["travel-view"]} shadow`}>
						<div className={`${styles["title-area"]} ${styles.txt}`}>
							<i className="tag tag-box tag-orange">숙박</i>
							<div className={styles.title}>가가펜션</div>
							<div className={styles["tag-area"]}>
								<span>#중분류</span>
								<span>#소분류</span>
							</div>
						</div>
					</div>
					<div className="shadow">
						<div className="padding pb_50">
							<div className={`${styles["list-item"]} ${styles.title}`}>
								<div>
									<span className="flex-align_center">
										<i className="icon_life icon_life_call icon mr_5" />
										전화
									</span>
									<span className={styles["btn-txt"]}>031-8078-8028</span>
								</div>
								<div>
									<span className="flex-align_center">
										<i className="icon_life icon_life_mail icon mr_5" />
										홈페이지
									</span>
									<span className={styles["btn-txt"]}>http://www.yangcheon.go.kr/</span>
								</div>
								<div>
									<span className="flex-align_center">
										<i className="icon_life icon_life_place icon mr_5" />
										주소
									</span>
									<span>서울 양천구 신정동 162-56(08104)<i className="icon icon_copy ml_10" /></span>
								</div>
							</div>
							<div className="img-box mt_20" style={{ height: "20rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={`${styles.content} mt_30`}>
								<p>소개</p>

								{/* 펼쳤을때 open 클래스 제거 */}
								<div className={`${styles.open} mt_10`}>럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
									럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
									럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
									럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
								</div>

								{/* 더보기 접기 */}
								<div className="flex-justify_center mt_30">
									<div className={styles.more} onClick={moreOpen}>더보기 <i className={`${styles.arrow} ${toggleButton ? styles.active : ""}`} /></div>
								</div>
							</div>
						</div>
					</div>

					<div className="padding">
						<div className={styles["list-item"]}>
							<div>
								<span className="flex-align_center">
									<i className="icon_life icon_life_user icon mr_5" />
									수용가능인원
								</span>
								<span>50명</span>
							</div>
							<div>
								<span className="flex-align_center">
									<i className="icon_life icon_life_parking icon mr_5" />
									주차시설
								</span>
								<span>불가능</span>
							</div>
							<div>
								<span className="flex-align_center">
									<i className="icon_life icon_life_time icon mr_5" />
									입실/퇴실시간
								</span>
								<span>15:00/11:00</span>
							</div>
						</div>

						<hr className="my_30" />
						<div>이용안내</div>
						<div className={`${styles["list-item"]} mt_20`}>
							<div>
								<span>규모</span>
								<span>70평, 3층</span>
							</div>
							<div>
								<span>객실 수</span>
								<span>6</span>
							</div>
							<div>
								<span>객실 유형</span>
								<span>호텔 I, 호텔 II</span>
							</div>
							<div>
								<span>픽업 서비스</span>
								<span>가능</span>
							</div>
						</div>

						<hr className="my_30" />
						<div>메뉴안내</div>
						<div className={`${styles["list-item"]} mt_20`}>
							<div>
								<span>취급메뉴</span>
								<span>메뉴명</span>
							</div>
							<div>
								<span>포장가능</span>
								<span>포장가능유무</span>
							</div>
						</div>

						<hr className="my_30" />
						<div className={`${styles["list-item"]} mt_20`}>
							<div className={styles.block}>
								<span>편의시설 및 서비스 안내</span>
								<span>객실 내 취사, 바비큐, 뷰티시설, 식음료장, 자전거 대여, 캠프파이어, 휘트니스, 노래방, 샤워실, PC실, 사우나, 세미나실, 스포츠 시설</span>
							</div>
						</div>

						<hr className="my_30" />
						<div>시설안내</div>
						<div className={`${styles["list-item"]} mt_20`}>
							<div>
								<span>식음료장</span>
								<span>없음</span>
							</div>
							<div className={styles.block}>
								<span>부대시설</span>
								<span>호텔 II = 레드플라워홀 1층 + 객실(2층, 3층), 더가든(야외 인조잔디 쉼터) + 남한강변 정원&amp;둘레길, 세미나실</span>
							</div>
						</div>

						<hr className="my_30" />
						<div>예약정보</div>
						<div className={`${styles["list-item"]} mt_20`}>
							<div>
								<span>예약안내</span>
								<span>전화, 홈페이지</span>
							</div>
							<div>
								<span>예약안내 홈페이지</span>
								<span className={styles["btn-txt"]}>https://hotel.naver.com/hotels/Item?hotelid=hotel:Chuok_pension</span>
							</div>
							<div>
								<span>환불규정</span>
								<span>없음</span>
							</div>
						</div>

						<div className={`${styles["detail-box"]} mt_40 mb_0`}>
							<div className={styles["list-item"]}>
								<div>
									<span>문의 및 안내</span>
									<span>양천구청 공원녹지과<br />02-2620-3576</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div className="flex-shrink_0 padding">
				<div className={styles["guide-bottom"]}>한국관광공사에서 받아오는 정보입니다.</div>
			</div>
		</div>
	)
}

export default TravelDetail7